export const VALIDATION_MODE = Object.freeze({
  SHOW: "ValidateAndShow",
  HIDE: "ValidateAndHide",
});
